/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from '@angular/core';
import { DepartmentsService } from '../../services/departments.service';
import { PopupService } from 'src/app/services/popup.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sample-dcp',
  templateUrl: './sample-dcp.component.html',
  styleUrls: ['./sample-dcp.component.scss']
})
export class SampleDcpComponent {
constructor(public _ds: DepartmentsService,public _pop:PopupService,public router: Router,){

}
onProduct(slug: any, subCatId: any, typeId: any) {
  // this.topmenuId=undefined;
  const uri = 'product/'+ slug
  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
  this.router.navigate([uri],{queryParams:{subCat:subCatId,category:typeId,isSamplechecked:true}}));
}
}
